module.exports = __webpack_public_path__ + "c637d3e36c7af6bda0f3a303137f1567.svg";